<div class="filters">
  <div class="filter-row filter-row-primary">
    <div class="filter-item filter-item-mode" *ngIf="!fixedRule">
      <span class="filter-item-label">{{ "WXRL.LOG.SEARCH" | translate }}</span>
      <div class="trigger">
        <p-radioButton
          name="searchType"
          value="rule"
          [(ngModel)]="searchType"
          (onChange)="onSearchTypeChanged($event)"
          [label]="'WXRL.LOG.SEARCH_BY_RULE_NUMBER' | translate"
        ></p-radioButton>
        <p-radioButton
          name="searchType"
          value="request"
          [(ngModel)]="searchType"
          (onChange)="onSearchTypeChanged($event)"
          [label]="'WXRL.LOG.SEARCH_BY_REQUEST_ID' | translate"
        ></p-radioButton>
      </div>
    </div>

    <div class="filter-item filter-item-id" *ngIf="!fixedRule">
      <label for="subjectID">{{ "WXRL.LOG.ID_TO_SEARCH" | translate }}</label>
      <input
        pInputText
        type="number"
        id="subjectID"
        [(ngModel)]="subjectID"
        [placeholder]="'WXRL.LOG.ID_TO_SEARCH' | translate"
      />
    </div>

    <div class="filter-item filter-item-date">
      <label for="startDate">{{ "WXRL.LOG.START_DATE" | translate }}</label>
      <p-calendar
        id="startDate"
        [(ngModel)]="desde"
        dateFormat="dd/mm/yy"
        placeholder="dd/mm/yyyy HH:mm:ss"
        [firstDayOfWeek]="1"
        [maxDate]="today"
        [showTime]="true"
        [showSeconds]="true"
        [hourFormat]="'24'"
        [showIcon]="false"
        styleClass="w-full"
      ></p-calendar>
    </div>

    <div class="filter-item filter-item-date">
      <label for="endDate">{{ "WXRL.LOG.END_DATE" | translate }}</label>
      <p-calendar
        id="endDate"
        [(ngModel)]="hasta"
        dateFormat="dd/mm/yy"
        placeholder="dd/mm/yyyy HH:mm:ss"
        [showTime]="true"
        [showSeconds]="true"
        [hourFormat]="'24'"
        [showIcon]="false"
        [firstDayOfWeek]="1"
        [minDate]="desde"
        [maxDate]="today"
        styleClass="w-full"
      ></p-calendar>
    </div>

    <div class="filter-item filter-item-max-rows">
      <label for="maxRows">{{ "WXRL.LOG.MAX_ROWS" | translate }}</label>
      <div class="max-rows-input">
        <input
          pInputText
          type="number"
          id="maxRows"
          [(ngModel)]="maxRows"
        />
        <span class="max-rows-suffix">{{ "WXRL.LOG.ROWS" | translate }}</span>
      </div>
    </div>

    <div class="filter-item filter-item-action">
      <button
        pButton
        label="{{ 'WXRL.LOG.SEARCH' | translate }}"
        icon="pi pi-search"
        (click)="onSearch()"
        class="search-button"
      ></button>
    </div>
  </div>

  <div class="filter-row filter-row-text">
    <div class="filter-item filter-item-text">
      <label for="logTextSearch">{{ "WXRL.LOG.SEARCH_TEXT" | translate }}</label>
      <input
        pInputText
        type="text"
        id="logTextSearch"
        [(ngModel)]="text"
        [placeholder]="'WXRL.LOG.SEARCHED_TEXT' | translate"
        (keyup.enter)="onSearch()"
      />
    </div>

    <div class="filter-item filter-item-occurrences" *ngIf="totalOccurrences > 0">
      <span class="occurrences-label">
        {{ "WXRL.LOG.OCCURRENCES" | translate }}:
        <span class="occurrences-count">{{ totalOccurrences }}</span>
      </span>
    </div>
  </div>
</div>
